<template>
  <div v-if="url" class="group cursor-pointer transform transition duration-200 flex items-center">
    <div class="flex justify-center items-center gap-4">
      <AtomIcon
        :icon="isPlaying ? 'app-pause' : 'app-play'"
        classes="text-white hover:text-white cursor-pointer transform transition duration-200 w-10 shrink-0"
        @click="toggleAudio"
      />

      <p class="text-white">
        <span v-if="composer" class="font-bold">{{ composer }}</span>
        {{ work }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  audioWork: { type: Object as PropType<Record<string, any>>, required: false, default: null },
  toggleHeaderAudio: { type: Function, required: false, default: () => {} },
})

const audioPlayerStore = useAudioPlayerStore()
const gtmCdpAction = setupGtmCdpAction()
const composer = computed(() => props.audioWork?.composers?.[0]?.title || '')
const work = computed(() => (props.audioWork?.parent?.id ? props.audioWork.parent.title : props.audioWork?.title || ''))
const url = computed(() => props.audioWork?.audio?.url || '')
const playerStates = computed(() => audioPlayerStore.playerStates)
const isPlaying = computed(() => props.audioWork && playerStates.value[props.audioWork.id])

function toggleAudio() {
  if (!isPlaying.value) {
    gtmCdpAction('CV07 - Header music fragment clicked')
  }
  if (props.audioWork) {
    audioPlayerStore.toggleAudio(props.audioWork.id)
  }
}

onBeforeUnmount(() => (isPlaying.value === true && props.audioWork ? audioPlayerStore.toggleAudio(props.audioWork.id) : null))
</script>

<style scoped lang="scss"></style>
